import { Component, OnInit, ChangeDetectionStrategy, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { icons } from './icons';
import { iconsV2 } from './iconsV2';

@Component({
  selector: 'at-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  host: {
    'class': 'at-icon'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent implements OnInit {
  @Input()
  set name(iconName: string) {
    this.element.nativeElement.innerHTML = iconsV2[iconName] || null;
  }
  w: number;

  @Input()
  set size(size: string) {
    const n = Number(size.replace('x', ''));
    this.w = 0.875 * n;
    this.element.nativeElement.lastChild.setAttribute('style', 'width: ' + this.w + 'rem; height: ' + this.w + 'rem;');
  }

  constructor(private element: ElementRef) { }

  ngOnInit() {
  }

}
